
  var _styles = {
  "one-col-container": {
    "borderRadius": "0.24rem",
    "backgroundColor": "rgb(255,255,255)",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "height": "2rem",
    "overflow": "hidden"
  },
  "one-col-left": {
    "width": "2.42667rem",
    "height": "100%",
    "paddingTop": "0.18667rem",
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem",
    "overflow": "hidden"
  },
  "one-col-left-content": {
    "boxSizing": "border-box",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "fontSize": 0,
    "overflow": "hidden"
  },
  "one-col-middle": {
    "flexGrow": 1,
    "overflow": "hidden",
    "maxWidth": "3.84rem",
    "position": "relative",
    "top": "-0.02667rem"
  },
  "one-col-right": {
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem"
  },
  "one-col-desc": {
    "position": "relative",
    "top": "-0.13333rem"
  }
};



  module.exports = _styles;
  